import { createContext, useContext } from 'react';

import { useControls } from './useControls';

const MenuContext = createContext<ReturnType<typeof useControls> | null>(null);

const useMenuContext = () => {
  return useContext(MenuContext);
};

export { MenuContext, useMenuContext };
